module.exports = __webpack_public_path__ + "img/icon_map_1_off_100.de2c71a6.png";